import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';

const EditCommissionCompanyModal = ({ show, handleClose, company, handleSave }) => {
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (company) {
            setName(company.name || '');
        }
    }, [company]);

    const handleSubmit = async () => {
        if (!name.trim()) {
            toast.error('Company name is required');
            return;
        }

        if (name.trim().length > 30) {
            toast.error('Company name must be 30 characters or less');
            return;
        }

        setLoading(true);
        try {
            const response = await api.put(`/commission-companies/${company.id}`, { name: name.trim() });
            if (response.data.status) {
                toast.success('Commission company updated successfully!');
                handleSave();
            } else {
                toast.error(response.data.message || 'Failed to update commission company');
            }
        } catch (error) {
            console.error('Error updating commission company:', error);
            toast.error(error.response?.data?.message || 'Error updating commission company');
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setName('');
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleCloseModal} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Commission Company</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="name" className="mb-3">
                        <Form.Label>
                            Company Name <span className="text-danger">*</span>
                            <span className="text-muted fw-normal"> (Max 30 characters)</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter company name"
                            required
                            maxLength={30}
                        />
                        <Form.Text className="text-muted">
                            {name.length}/30 characters
                        </Form.Text>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal} disabled={loading}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? <><Spinner animation="border" size="sm" className="me-2" /> Saving...</> : 'Save Changes'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditCommissionCompanyModal;
